/*
 * This should only ever be done in development! This is an expensive operation.
 * Mutating state breaks the react/redux dogma. It is error prone and causes
 * unforeseen bugs in the application that can be incredibly hard to find.
 * The reason we freeze state in development is to find and prevent state mutation.
 * https://redux.js.org/troubleshooting#never-mutate-reducer-arguments
 */
import { AnyAction, Middleware } from 'redux';
import { isExplorer, isBrowser } from 'utils';

function deepFreeze(o: Record<string, unknown>) {
  if (o instanceof FileList) {
    return o;
  }
  Object.freeze(o);

  Object.getOwnPropertyNames(o).forEach(prop => {
    if (
      prop in o &&
      o[prop] !== null &&
      (typeof o[prop] === 'object' || typeof o[prop] === 'function') &&
      !Object.isFrozen(o[prop])
    ) {
      deepFreeze(o[prop] as Record<string, unknown>);
    }
  });
  return o;
}
export default function freeze(): Middleware {
  return store => next => (action: AnyAction) => {
    if (process.env.NODE_ENV === 'development') {
      if (isBrowser() && !isExplorer()) {
        deepFreeze(store.getState());
      }
      try {
        return next(action);
      } finally {
        if (isBrowser() && !isExplorer()) {
          deepFreeze(store.getState());
        }
      }
    }
    return next(action);
  };
}
